<template><div><h1 id="inventurliste-export-fur-excel" tabindex="-1"><a class="header-anchor" href="#inventurliste-export-fur-excel"><span>Inventurliste, Export für Excel</span></a></h1>
<p>Inventurliste, Export für Excel — Details zu einer Inventur</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste mit detaillierten Informationen über die gewünschte Inventurnummer. Nur Inventurpositionen mit Status X werden aufbereitet und in einer tabulatorgetrennten Datei ausgegeben. Es wird empfohlen, die Funktionalität &quot;Inventur&quot; im Modul <RouteLink to="/manual/trade/artikel_und_lagerverwaltung.html" title="3. Artikel- und Lagerverwaltung">Lagerverwaltung</RouteLink> zu verwenden, da dort nebst dem Bestand auch der Lagerwert ausgegeben werden kann.</p>
<p>Pfad: <code v-pre>Logistik → Auswertungen → Inventurliste</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Job-Nr</dt>
<dd>Muss-Eingabe</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Artikel-Nr</td>
<td>Artikelnummer</td>
</tr>
<tr>
<td>Artikel-Bezeichnung</td>
<td>Artikel-Bezeichnung</td>
</tr>
<tr>
<td>Artikel-Konto</td>
<td>Ertragskonto des Artikels</td>
</tr>
<tr>
<td>Artikel-Kostenstelle</td>
<td>Ertragskostenstelle des Artikels</td>
</tr>
<tr>
<td>Artikel-Kostenträger</td>
<td>Ertragskostenträger des Artikels</td>
</tr>
<tr>
<td>MWST-Code</td>
<td>MWST-Code</td>
</tr>
<tr>
<td>Satz %</td>
<td>MWST-Satz</td>
</tr>
<tr>
<td>Artikel-VPreis</td>
<td>Verkaufspreis</td>
</tr>
<tr>
<td>EPr</td>
<td>Einkaufspreis</td>
</tr>
<tr>
<td>Bestand Stück</td>
<td>Artikelbestand: Lagerbestand in funtrade (zum Inventurdatum)</td>
</tr>
<tr>
<td>gezählt Stück</td>
<td>Artikelbestand: gezählte Menge (sobald eingegeben)</td>
</tr>
</tbody>
</table>
<p>Inventurliste Job-Nr.:10.05.2000   1            Datum der Sperrung :10.05.2000
Artikel-        Artikel-        MWSt-   Satz    EPr.    Bestand gezählt
Nr.             Bezeichnung     Code    %               Stück   Stück
029700  Briefbeschwerer         i       7.5     16.20   80      78
039600  Briefbeschwerer2        i       7.5     14.80   110     110
.
.</p>
<p>Lesebeispiel: Artikel &quot;Briefbeschwerer&quot; wird mit 7,5 % Mehrwertsteuer im System geführt. Der Einkaufspreis beträgt Fr. 16.20. Der Bestand des Artikels im System war zum Inventurdatum 80 Stück (Summe aus allen Lagerorten). Die Inventur hat einen gezählten Bestand von 78 ergeben.</p>
</div></template>


